export const getBatchedArray = (arr, batchSize = 100) => {
  const arrayLength = arr.length;
  let batchedArray = [];
  for (let index = 0; index < arrayLength; index += batchSize) {
    const batch = arr.slice(index, index + batchSize);
    batchedArray.push(batch);
  }
  return batchedArray;
};
